
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/research/[[...slug]]",
      function () {
        return require("private-next-pages/research/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/research/[[...slug]]"])
      });
    }
  